import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';
import type { IUser, IUserSignInData } from 'api/types/user';

export const signInUser = async (data: IUserSignInData) => {
    const response = await apiClient.post('sessions/native', {
        json: { ...data },
    });
    return (await response.json()) as IUser;
};

export const useSignInMutation = (
    options: UseMutationOptions<IUser, IRequestException, IUserSignInData>
) => {
    return useMutation<IUser, IRequestException, IUserSignInData>(
        async (data) => await signInUser(data),
        options
    );
};
